import React, {useState } from "react";
import { Field, useFormikContext  } from "formik";
import InputField from "~components/Form/components/InputField";
import Select from "~components/Form/components/Select";

const FormMapping = ({ 
  index, 
  funilObraGruposProduto, 
  funilObraUnidadeMedidas, 
  data,
  updateData
}) => {
  const { errors, touched, setFieldValue } = useFormikContext();

  const onChangeConsume = (checked) => {
    const toChange = {
      semConsumo: checked,
      volumeMapeado: checked && String(data.volumeMapeado ?? "").length ? "" : data.volumeMapeado,
      volumeNegociado: checked && String(data.volumeNegociado ?? "").length ? "" : data.volumeNegociado,
    };
    setFieldValue(`[${index}]`, {
      ...data,
      ...toChange
    });

    updateData({ id: data.id, data: {
      ...toChange
    }})
  }

  const handleChange = ({field, value}) => {
    setFieldValue(`[${index}].${field}`, value);
    updateData({ id: data.id, data: {
      [field]: value,
    }})
  }

  return (
    <div className="mb-14">
      <div className="funnel-principal-form grid grid-cols-2 gap-x-4 ">
        <Select
          options={funilObraGruposProduto}
          label="Grupo Produto:"
          name={`[${index}].funilObraGrupoProdutoId`}
          placeholder="Grupo Produto"
          value={funilObraGruposProduto.find(e => e.value == data.funilObraGrupoProdutoId)}
          isDisabled={true}
          spacingControl={true}
          error={errors?.[index]?.funilObraGrupoProdutoId}
          touched={touched?.[index]?.funilObraGrupoProdutoId}
        />

        <InputField
          labelName="Data de Negociação:"
          inputName={`[${index}].dataNegociacao`}
          inputMask="offmask"
          inputType="month"
          isRequired={true}
          value={data.dataNegociacao}
          onChangeEvent={(e) => {
            handleChange({field: "dataNegociacao", value: e.target.value})
          }}
          isDisabled={data.semConsumo}
          error={errors?.[index]?.dataNegociacao}
          touched={touched?.[index]?.dataNegociacao}
        />

        <Select
          options={funilObraUnidadeMedidas}
          label="Unidade de Medida:"
          name={`[${index}].unidadeMedidaId`}
          placeholder="Unidade de Medida"
          value={funilObraUnidadeMedidas.find(e => e.value == data.funilObraUnidadeMedidaId)}
          isDisabled={true}
          spacingControl={true}
          error={errors?.[index]?.unidadeMedidaId}
          touched={touched?.[index]?.unidadeMedidaId}
        />

        <div className="flex gap-x-2">
          <InputField
            labelName="Volume Mapeado:"
            tooltip="Volume total estimado para obra"
            inputName={`[${index}].volumeMapeado`}
            inputMask="offmask"
            inputType="number"
            isRequired={false}
            isDisabled={data.semConsumo}
            value={data.volumeMapeado}
            placeholder="Volume Mapeado"
            onWheel={(e) => e.target.blur()}
            onChangeEvent={(e) => {
              handleChange({field: "volumeMapeado", value: parseInt(e.target.value ?? 0)})
            }}
            error={errors?.[index]?.volumeMapeado}
            touched={touched?.[index]?.volumeMapeado}
          />

          <InputField
            labelName="Volume Negociado:"
            tooltip={"Volume em negociação"}
            inputName={`[${index}].volumeNegociado`}
            inputMask="offmask"
            inputType="number"
            isRequired={false}
            isDisabled={data.semConsumo}
            value={data.volumeNegociado}
            placeholder="Volume Negociado"
            onWheel={(e) => e.target.blur()}
            onChangeEvent={(e) => {
              handleChange({field: "volumeNegociado", value: parseInt(e.target.value ?? 0)})
            }}
            error={errors?.[index]?.volumeNegociado}
            touched={touched?.[index]?.volumeNegociado}
          />
        </div>
      </div>

      <label className="flex items-center space-x-2 ml-1">
        <Field
          type="checkbox"
          checked={data.semConsumo}
          name={`[${index}].semConsumo`}
          className="h-5 w-5 rounded-lg text-indigo-600 border-gray-300 focus:ring-indigo-500 checked:bg-yellow-400 checked:border-transparent checked:text-blue-500 accent-terciaria"
          onChange={(e) => {
            onChangeConsume(e.target.checked);
          }}
        />
        <span className="text-gray-700">Sem Consumo</span>
      </label>
    </div>
  );
};

export default FormMapping;
